import UtagHelper from 'utilities/utagHelper';
import {
    recordEvent,
    recordError,
    recordEventCustomOnly,
    recordCreateNewClient,
    PAGE_PRODUCT,
    errorTag,
    recordEventStepSuccess,
} from 'utilities/uTagging';
import { PATH_CONTACT } from 'constants/uTagConstants/paths';
import {
    ERROR_AL_AGREGAR_INFORMACION_ADICIONAL,
    ERROR_AL_VALIDAR_LOS_DATOS_DEL_CLIENTE,
} from 'constants/analyticsErrors';

export const doTagValidateFields = () =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'clic',
        etiquetaEvento: 'continuar',
        event_name: 'button_click',
        action: 'click',
        format: 'button',
        component: 'form',
        element: 'continue',
    });
export const doTagCancel = () =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'clic',
        etiquetaEvento: 'salir',
    });

export const doTagCreateNewClient = ({ userProfile, userId }) => {
    const { promoCode, investmentType, product, recordId } = userProfile;

    const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

    recordCreateNewClient(
        recordId,
        userId,
        product,
        promoCode ? promoCode : '',
        '',
        '',
        investmentType ? investmentType : 'robo',
        jointHolderInfo
    );
};

export const doTagCloseDepositWarning = () =>
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/completa-tus-datos-generales/',
        accionEvento: 'depositos/aviso-titulares/modal',
        etiquetaEvento: 'entendido',
    });

export const doTagCompleteYourData = ({ recordId, investmentType, docNumberEncrypted }) => {
    recordEvent(
        PATH_CONTACT,
        PAGE_PRODUCT,
        'completa tus datos generales',
        'completa tus datos generales correcto',
        recordId,
        '',
        '',
        investmentType,
        docNumberEncrypted
    );
};

export const doTagCompleteYourDataSuccessful = investmentType => {
    recordEventStepSuccess(
        investmentType,
        '/onboarding/completa-tus-datos-generales',
        'completa tus datos personales',
        {
            event_name: 'event_success',
            action: 'success',
            format: 'steps',
            component: 'funnel',
            element: 'general data',
        }
    );
};

export const doTagFieldsWithError = ({ fieldsWithError, investmentType }) =>
    recordError(`[${fieldsWithError}]:Campos requeridos para continuar.`, investmentType ?? '');

export const doTagCompleteYourDataIncorrect = ({ recordId, investmentType, docNumberEncrypted }) =>
    recordEvent(
        PATH_CONTACT,
        PAGE_PRODUCT,
        'completa tus datos generales',
        'completa tus datos generales incorrecto',
        recordId,
        '',
        '',
        investmentType ?? '',
        docNumberEncrypted
    );

export const doTagCreditCardCheckboxChecked = ({ investmentType, docNumberEncrypted }) =>
    recordEvent(
        PATH_CONTACT,
        PAGE_PRODUCT,
        'tarjeta de credito checkbox',
        'tarjeta de credito checkbox checkeado',
        '',
        '',
        '',
        investmentType,
        docNumberEncrypted
    );

export const doTagCreditCardCheckboxUnchecked = ({ investmentType, docNumberEncrypted }) =>
    recordEvent(
        PATH_CONTACT,
        PAGE_PRODUCT,
        'tarjeta de credito checkbox',
        'tarjeta de credito checkbox no checkeado',
        '',
        '',
        '',
        investmentType,
        docNumberEncrypted
    );

export const doTagCompleteYourDataJointHolders = ({ recordId, investmentType, docNumberEncrypted }) =>
    recordEvent(
        PATH_CONTACT,
        PAGE_PRODUCT,
        'completa tus datos generales',
        'completa tus datos generales correcto',
        recordId,
        '',
        '',
        investmentType,
        docNumberEncrypted
    );

export const doTagCompleteYourDataJointHoldersSuccessful = investmentType =>
    recordEventStepSuccess(investmentType, '/onboarding/completa-tus-datos-generales', 'completa tus datos personales');

export const doTagCompleteYourDataJointHoldersDepositAdvise = () =>
    recordEventCustomOnly({
        categoriaEvento: '/onboarding/completa-tus-datos-generales/',
        accionEvento: 'depositos/aviso-titulares/modal',
        etiquetaEvento: 'vista',
    });

export const doTagClienVerifyError = ({ body, statusCode }) =>
    errorTag(body, PATH_CONTACT, ERROR_AL_VALIDAR_LOS_DATOS_DEL_CLIENTE, statusCode);

export const doTagSubmitError = ({ body, statusCode }) =>
    errorTag(body, PATH_CONTACT, ERROR_AL_AGREGAR_INFORMACION_ADICIONAL, statusCode);
